/**
* Below function is used to collect the cart data from (trackingDataLayer or utag_data) & send to Inwise API.
*/

var generic = generic || {};
Drupal.behaviors.inwiseCheckoutConfirm = {
  attach: function() {
    var $checkoutConfirmPage = $('#confirm-panel');
    if ($checkoutConfirmPage.length && window.location.href.indexOf('?TID=') > -1) {
      $(document).trigger('checkoutConfirm.success');
    }
  }
};

$(document).on('cartChange.success , cartRemove.success , addToCart.success , recommendedProduct.success , checkoutConfirm.success', function(event) {
  var trackingDataLayer = event.type === 'checkoutConfirm' ? window.utag_data : window.site.trackingDataLayer.data;
  var tmsPageData = window.tms_page_data;
  if (trackingDataLayer && tmsPageData) {
    var productLength = trackingDataLayer.cart_product_id ? trackingDataLayer.cart_product_id.length : 0;
    var hostName = 'https://' + window.location.host;
    var userAgent = 'User-agent header sent: ' + navigator.userAgent;
    var customerId = trackingDataLayer.CUSTOMER_ID ? trackingDataLayer.CUSTOMER_ID : 'Guest User';
    var cartItemLength = $('.cart-item').length;
    var args = {
      'event': event.type,
      'productLength': productLength,
      'customerId': customerId,
      'userAgent': userAgent,
      'hostName': hostName,
      'cartItemLength': cartItemLength,
    };
    createInwiseProductData(args, trackingDataLayer);
  }
});

function image_url(i, args, trackingDataLayer) {
  var imageData = '';
  if (trackingDataLayer.cart_product_sku_large_image_url[i]) {
    imageData = args.hostName + trackingDataLayer.cart_product_sku_large_image_url[i];
  } else if (trackingDataLayer.cart_product_sku_small_image_url[i]) {
    imageData = args.hostName + trackingDataLayer.cart_product_sku_small_image_url[i];
  }
  return imageData;
}

function createInwiseProductData(args, trackingDataLayer) {
  if (args.event === 'addToCart' || args.event === 'checkoutConfirm') {
    args.cartItemLength = 1;
  }
  var productData = {};
  productData.final = [];
  if (args.cartItemLength && args.productLength) {
    for (var i = 0; i < args.productLength; i++) {
      productData.final.push({
        id: String(trackingDataLayer.cart_product_id[i]),
        name: trackingDataLayer.cart_product_name[i],
        description: trackingDataLayer.cart_product_short_desc[i],
        brand: trackingDataLayer.brand,
        sku: trackingDataLayer.cart_product_sku[i],
        category: trackingDataLayer.cart_product_category[i],
        product_url: args.hostName + trackingDataLayer.cart_product_url[i],
        image_url: image_url(i, args, trackingDataLayer),
        quantity: parseInt(trackingDataLayer.cart_product_quantity[i]),
        unit_price: parseInt(trackingDataLayer.cart_product_price[i]),
        total_price: parseInt(trackingDataLayer.cart_product_price[i]) * parseInt(trackingDataLayer.cart_product_quantity[i]),
      });
    }
  }
  createInwiseUserData(productData.final, args, trackingDataLayer);
}

function createInwiseUserData(productData, args, trackingDataLayer) {
  var InwiseData = {
    'customer_cart_id': String(trackingDataLayer.cart_product_cart_id[0]),
    'customer_id': String(args.customerId),
    'products': productData,
    'origin_user_agent': args.userAgent,
    'sub_total': args.cartItemLength ? trackingDataLayer.cart_total_value : 0,
  };
  var cartProductQuantity = trackingDataLayer.cart_product_quantity[0] ? trackingDataLayer.cart_product_quantity[0] : 0;
  if ((args.event === 'addToCart' || args.event === 'recommendedProduct') && (cartProductQuantity === 1 && trackingDataLayer.cart_product_quantity.length === 1)) {
    InwiseData.create_contact = true;
  }
  var getEventType = {
    'addToCart': 'SHOPPING',
    'recommendedProduct': 'SHOPPING',
    'cartChange': 'CART_UPDATE',
    'cartRemove': 'CART_UPDATE',
    'checkoutConfirm': 'ORDER_COMPLETE',
  };
  var setEventType = getEventType[args.event];
  InwiseData.phase = setEventType;
  console.log(InwiseData);
  sendInwiseData(InwiseData);
}
function sendInwiseData(InwiseData) {
  generic.jsonrpc.fetch({
    method: 'inwise.sendCartDetails',
    params: [InwiseData],
    onSuccess: function(jsonRpcResponse) {
      return jsonRpcResponse;
    },
    onFailure: function(jsonRpcResponse) {
      return jsonRpcResponse;
    }
  });
}
